webpackJsonp([69],{

/***/ 657:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rails_ujs__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rails_ujs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rails_ujs__);


function handleDeleteStatus(event) {
  var _event$detail = event.detail,
      data = _event$detail[0];

  var element = document.querySelector('[data-id="' + data.id + '"]');
  if (element) {
    element.parentNode.removeChild(element);
  }
}

[].forEach.call(document.querySelectorAll('.trash-button'), function (content) {
  content.addEventListener('ajax:success', handleDeleteStatus);
});

var batchCheckboxClassName = '.batch-checkbox input[type="checkbox"]';

Object(__WEBPACK_IMPORTED_MODULE_0_rails_ujs__["delegate"])(document, '#batch_checkbox_all', 'change', function (_ref) {
  var target = _ref.target;

  [].forEach.call(document.querySelectorAll(batchCheckboxClassName), function (content) {
    content.checked = target.checked;
  });
});

Object(__WEBPACK_IMPORTED_MODULE_0_rails_ujs__["delegate"])(document, batchCheckboxClassName, 'change', function () {
  var checkAllElement = document.querySelector('#batch_checkbox_all');
  if (checkAllElement) {
    checkAllElement.checked = [].every.call(document.querySelectorAll(batchCheckboxClassName), function (content) {
      return content.checked;
    });
  }
});

Object(__WEBPACK_IMPORTED_MODULE_0_rails_ujs__["delegate"])(document, '.media-spoiler-show-button', 'click', function () {
  [].forEach.call(document.querySelectorAll('button.media-spoiler'), function (element) {
    element.click();
  });
});

Object(__WEBPACK_IMPORTED_MODULE_0_rails_ujs__["delegate"])(document, '.media-spoiler-hide-button', 'click', function () {
  [].forEach.call(document.querySelectorAll('.spoiler-button.spoiler-button--visible button'), function (element) {
    element.click();
  });
});

/***/ })

},[657]);


// WEBPACK FOOTER //
// admin.js